module.exports = __webpack_public_path__ + "img/store-dne-token.a8511468.jpg";